module.exports = __webpack_public_path__ + "img/zimbabwe.ae6217ee.svg";